module.exports = __webpack_public_path__ + "static/img/indexPic4.2914cd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic4.png
// module id = UrD8
// module chunks = 1